import { Controller } from "@hotwired/stimulus"

/**
 * Hides field-source rows that don't apply to the currently selected
 * `source_mode`. The `_field_form.html.erb` drawer renders all five
 * source-mode rows simultaneously (column, from_step, from_step_attr,
 * sources, literal); without this controller, operators routinely fill
 * in the wrong row and the parser silently picks one.
 *
 * Each row carries `data-field-source-mode-row-modes-value` (a CSV of
 * applicable modes). The select with `data-field-source-mode-target=
 * "modeSelect"` drives the visibility on connect and on change.
 *
 * Pure UI gating — does not mutate values when rows hide. The accept
 * layer in ApplyPipelineStageEdit already branches on `source_mode`, so
 * a hidden row's value is ignored at parse time anyway.
 */
export default class extends Controller {
  static targets = ["modeSelect", "row"]

  declare readonly modeSelectTarget: HTMLSelectElement
  declare readonly rowTargets: HTMLElement[]

  connect(): void {
    this.applyMode()
  }

  modeChanged(): void {
    this.applyMode()
  }

  private applyMode(): void {
    const active = this.modeSelectTarget.value
    for (const row of this.rowTargets) {
      const modes = (row.dataset.modes || "").split(",").map((m) => m.trim()).filter(Boolean)
      const matches = modes.length === 0 || modes.includes(active)
      row.classList.toggle("hidden", !matches)
    }
  }
}
